import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'ngde-footer',
  imports: [RouterLink],
  standalone: true,
  template: `
    <footer class="bg-gray-900 text-white py-12">
      <div class="container mx-auto px-4">
        <div
          class="flex flex-col md:flex-row justify-between items-center mb-8"
        >
          <div class="flex items-center space-x-2 mb-6 md:mb-0">
            <img src="assets/logo.svg" alt="NG-DE Logo" class="h-10 w-10" />
            <div>
              <h3 class="text-xl font-bold">
                <span
                  class="bg-clip-text text-transparent bg-gradient-to-r from-primary-400 to-secondary-400"
                >
                  NG-DE
                </span>
              </h3>
              <p class="text-xs text-gray-400">November 5-7, 2025 • Berlin</p>
            </div>
          </div>

          <div class="flex space-x-4">
            <a
              href="https://github.com/ngdeconf/ng-de.org"
              target="_blank"
              class="text-gray-400 hover:text-white transition-colors"
            >
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/ngdeconf/"
              target="_blank"
              class="text-gray-400 hover:text-white transition-colors"
            >
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/ngdeconf"
              target="_blank"
              class="text-gray-400 hover:text-white transition-colors"
            >
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
              </svg>
            </a>
          </div>
        </div>

        <!-- Funded by section -->
        <div class="border-t border-gray-800 pt-8 pb-6">
          <div class="flex flex-col items-center justify-center space-y-4">
            <span class="text-gray-400 text-sm font-medium">Funded by</span>
            <img 
              src="assets/images/berlin-senate-logo.png" 
              alt="Senatsverwaltung für Wirtschaft, Energie und Betriebe Berlin" 
              class="h-12 md:h-16 opacity-80 hover:opacity-100 transition-opacity"
            />
            <div class="text-center">
              <p class="text-gray-500 text-xs">
                Förderrichtlinie<br>
                „Kongressfonds für nachhaltiges Tagen"
              </p>
            </div>
          </div>
        </div>

        <div
          class="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm"
        >
          <p>&copy; {{ currentYear }} NG-DE Berlin. All rights reserved.</p>
          <div class="mt-2 space-x-4">
            <a
              routerLink="/privacy-policy"
              class="hover:text-white transition-colors"
              >Privacy Policy</a
            >
            <a routerLink="/imprint" class="hover:text-white transition-colors"
              >Imprint</a
            >
            <a
              routerLink="/code-of-conduct"
              class="hover:text-white transition-colors"
              >Code of Conduct</a
            >
          </div>
        </div>
      </div>
    </footer>
  `
})
export class FooterComponent {
  get currentYear(): number {
    return new Date().getFullYear();
  }
}
